@import 'styles/mixins';
@import 'styles/variables';

.moreButton {
  border-radius: 23px;
}
